var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchBox',{ref:"searchbox",attrs:{"label":(_vm.hidelabel) ? '' : 'Profissão:',"hidelabel":_vm.hidelabel,"placeholder":"Busca Profissão por Nome ou Código","funcaoBuscar":"getProfissoesBox","incluir":_vm.incluir,"alterar":_vm.alterar,"tipo":"profissao"},on:{"selected":_vm.handleSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }